// Colores de rango · escala de progresión.
//
// Misma escala que la plataforma del distribuidor, para que un rango se
// vea igual en los dos productos. Reemplaza la paleta de colores puros
// (#FFD700, #0000FF, #C0C0C0…) que no convive con el sistema nuevo.

const RANKS = {
  'aprendiz elite':     { color: '#8B80FF', bg: '#F3F1FE' },
  'constructor':        { color: '#6E63FF', bg: '#F0EEFE' },
  'master':             { color: '#4B36F0', bg: '#EDEBFD' },
  'esmeralda':          { color: '#0F9A5A', bg: '#F0FBF4' },
  'diamante':           { color: '#0E7490', bg: '#EFF9FC' },
  'diamante embajador': { color: '#7C3AED', bg: '#F6F1FE' },
};

const DEFAULT = { color: '#8A91AE', bg: '#F5F6FA' };

const normalize = (name) =>
  String(name || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z\s]/gi, '')   // cubre "Diamante Embajador Estrella 🌟"
    .trim()
    .toLowerCase();

export const getRankTone = (rankName) => {
  const name = normalize(rankName);
  if (RANKS[name]) return RANKS[name];
  const match = Object.keys(RANKS).find((key) => name.startsWith(key));
  return match ? RANKS[match] : DEFAULT;
};

export const getRankColor = (rankName) => getRankTone(rankName).color;
